export default "../css/bf2d7f7f7f2e489bc43d98071d273fdb.ttf";